module.exports = __webpack_public_path__ + "static/media/boat-img-5.6df18eac.jpg";